import { Host } from '../Host';

type Reading = {
    time: number,
    offset: number,
    localTime: number,
};

const readings = [] as Reading[];

const avgOffset = () => readings.map(x => x.offset).reduce((a, b) => a + b, 0) / readings.length;
const lastReading = () => readings[readings.length - 1];

const endpoint = `${Host.baseUrl}/server-time`;
const performSync = async (trips: number) => {

    for (let i = 0; i < trips; i++) {

        const t1 = Date.now();
        const resp = await fetch(endpoint);
        const t4 = Date.now();
        const t23 = parseInt(resp.headers.get('x-time'));

        const time = (await resp.json()).now;
        const offset = (t4 - t1 - t23) / 2;

        readings.push({ time, offset, localTime: Date.now() });
        await new Promise(rs => setTimeout(rs, 200 * (i * .75)));
    }
};

export const ServerDate = {

    sync() {
        if (Host.offline) return;
        performSync(8);
    },

    now() {
        if (readings.length > 3) {
            const { time, localTime } = lastReading();
            return time + avgOffset() + (Date.now() - localTime);
        }
        else {
            return Date.now();
        }
    }
};
